import SettingsModal from './SettingsModal'

// Composant qui regroupe toutes les modales de l'application
const Modals = () => {
  return (
    <>
      <SettingsModal />
      {/* Ajoutez d'autres modales ici au besoin */}
    </>
  )
}

export default Modals

